// src/services/api/empresa.js
import axios from '@/services/axios';

// Lê metadados (conta bytes das imagens)
export function getEmpresa() {
  return axios.get('/configuracoes/empresa');
}

// URLs canônicas para exibir imagens direto do bytea
export function getLogomarcaURL() {
  // use /api/ para funcionar tanto no DEV quanto atrás do proxy
  return '/api/configuracoes/empresa/logomarca';
}
export function getPlanoFundoURL() {
  return '/api/configuracoes/empresa/plano-fundo';
}

// Atualiza dados + (opcionais) imagens via multipart/form-data
export async function updateEmpresa(payload, files = {}) {
  const fd = new FormData();

  // Campos textuais (só adiciona se estiverem definidos)
  const add = (k, v) => {
    if (v !== undefined && v !== null) fd.append(k, String(v));
  };

  add('razao_social', payload.razao_social);
  add('nome_fantasia', payload.nome_fantasia);
  add('cnpj', payload.cnpj);
  add('slogan', payload.slogan);
  add('telefone1', payload.telefone1);
  add('telefone2', payload.telefone2);
  add('email', payload.email);
  add('endereco', payload.endereco);
  add('numero', payload.numero);
  add('complemento', payload.complemento);
  add('bairro', payload.bairro);
  add('cep', payload.cep);
  add('estado_cod', payload.estado_cod);
  add('municipio_cod', payload.municipio_cod);
  add('site', payload.site);
  add('whatsapp_url', payload.whatsapp_url);
  add('instagram_url', payload.instagram_url);
  add('facebook_url', payload.facebook_url);
  add('youtube_url', payload.youtube_url);
  add('x_url', payload.x_url);
  add('linkedin_url', payload.linkedin_url);

  // Imagens (opcionais). Os nomes dos campos PRECISAM bater com o backend:
  //   logomarca  | plano_de_fundo
  if (files.logomarca instanceof File) {
    fd.append('logomarca', files.logomarca);
  }
  if (files.plano_de_fundo instanceof File) {
    fd.append('plano_de_fundo', files.plano_de_fundo);
  }

  const { data } = await axios.put('/configuracoes/empresa', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}
